// extracted by mini-css-extract-plugin
export var leftAlign = "_1u-2";
export var popper = "_1u-0";
export var subtitle = "_1u-1";